import { toDigits } from './toDigits';

const AREA_CODE_END = 3;
const PREFIX_END = 6;
const PHONE_DIGITS = 10;

export const toPhoneString = (value?: string | number | null): string => {
  const digits = toDigits(value).slice(0, PHONE_DIGITS);

  if (digits.length === 0) {
    return '';
  }

  if (digits.length <= AREA_CODE_END) {
    return `(${digits}`;
  }

  if (digits.length <= PREFIX_END) {
    return `(${digits.slice(0, AREA_CODE_END)}) ${digits.slice(AREA_CODE_END)}`;
  }

  return `(${digits.slice(0, AREA_CODE_END)}) ${digits.slice(
    AREA_CODE_END,
    PREFIX_END,
  )}-${digits.slice(PREFIX_END)}`;
};
